/* eslint-disable @typescript-eslint/naming-convention */
import React, { createContext, useEffect } from "react";
import { useLocalStorageHook } from "@dealer-center/core-components";

interface TableAttributesProviderProps {
  children: React.ReactElement | React.ReactElement[];
}

export interface TableAttributesContextInterface {
  selectedAttributes: string[];
  setSelectedAttributes: (selectedAttributes: string[]) => void;
}

export const ALL_TABLE_ATTRIBUTES: string[] = [
  "ACTION_NEEDED",
  "SOURCE",
  "CONDITION",
  "YEARS",
  "MAKE",
  "MODELS",
  "OFFER",
  "TYPE",
  "CONDITIONAL_OFFER",
  "FEATURED",
  "EFFECTIVE_DATE",
  "EXPIRATION_DATE",
  "TOTAL_CASH_BACK",
  "MO24",
  "MO36",
  "MO39",
  "MO42",
  "MO48",
  "MO60",
  "MO72",
  "CUSTOM_LENGTH",
  "CUSTOM_RATE",
  "MSRP",
  "CASH_DUE",
  "RESIDUAL_VALUE",
  "VIN",
  "SHORT_TITLE"
];

const DEFAULT_ATTRIBUTES: string[] = [
  "ACTION_NEEDED",
  "SOURCE",
  "CONDITION",
  "MAKE",
  "MODELS",
  "OFFER",
  "TYPE",
  "CONDITIONAL_OFFER",
  "EFFECTIVE_DATE",
  "EXPIRATION_DATE",
  "TOTAL_CASH_BACK",
  "SHORT_TITLE"
];

export const TableAttributesContext = createContext({
  selectedAttributes: DEFAULT_ATTRIBUTES,
  setSelectedAttributes: () => {
    return null;
  }
} as TableAttributesContextInterface);

const validateAttributes = (attributes: string[]): string[] => {
  return ALL_TABLE_ATTRIBUTES.filter(attr => attributes.includes(attr));
};

export const TableAttributesProvider = ({
  children
}: TableAttributesProviderProps) => {
  const [selectedAttributes, setSelectedAttributes] = useLocalStorageHook<
    string[]
  >("incentivesManagerTableAttributes", DEFAULT_ATTRIBUTES);

  // This will ensure that we don't get any invalid attributes from local storage
  //
  useEffect(() => {
    setSelectedAttributes(validateAttributes(selectedAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableAttributesContext.Provider
      value={{
        selectedAttributes,
        setSelectedAttributes: (attributes: string[]) => {
          setSelectedAttributes(validateAttributes(attributes));
        }
      }}
    >
      {children}
    </TableAttributesContext.Provider>
  );
};
